import React, { useState, useEffect } from 'react';
import './GenerativeEnterprise.css';
import img1 from "../generativeassets/gen1.png";
import img2 from "../generativeassets/gen2.png";
import img3 from "../generativeassets/gen3.png";
import img4 from "../generativeassets/gen4.png";

const cards = [
  {
    img: img1,
    color:"#1868DB",
    head: "Generative AI for Customer Experience",
    subhead:
      "We build secure GenAI solutions using encryption, access controls, and monitoring to protect sensitive data and ensure enterprise-grade integrity.",
  },
  {
    img: img2,
     color:" #FF751A",
    head: "Generative AI for Operational Efficiency",
    subhead:
      "We prioritize fairness, transparency, and privacy at every stage. Our models are responsibly designed and trained to mitigate bias, ensuring inclusive, trustworthy AI aligned with global compliance standards.",
  },
  {
    img: img3,
     color:"#00A524",
    head: "Generative AI for Sales Acceleration",
    subhead:
      "We design AI systems that are easy to use and easy to trust. Clear, thoughtful interfaces enable users to interact effortlessly and realize value without added complexity.",
  },
  {
    img: img4,
     color:"#0B0FC7",
    head: "Generative AI for Enterprise",
    subhead:
      "We apply rigorous quality assurance across development and training, including continuous testing, validation, and monitoring to ensure accuracy, relevance, and consistent performance.",
  }
];

const ChevronLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
);

const ChevronRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

export default function GenerativeEnterprise() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsPerSlide, setCardsPerSlide] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setCardsPerSlide(4); 
      } else if (window.innerWidth >= 768) {
        setCardsPerSlide(2);
      } else {
        setCardsPerSlide(1);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const totalSlides = Math.ceil(cards.length / cardsPerSlide);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  return (
    <div id='generative-enterprise' className='generativemainclass'>
      <div className="top">
        <h2 className="heading">
          Start Your AI Journey Today
        </h2>
        <p className="subheading">
          A clear, practical, and outcome-focused approach to building and scaling GenAI solutions, step by step.  
        </p>
      </div>
      <div className="cards">
        {cards.map((card) => {
          return (
            <div className="card" key={card.head}>
              <div className="image">
                <img src={card.img} alt="error" />
              </div>
              <div className="content">
                <h3 style={{color:card.color}}>{card.head}</h3>
                <span>{card.subhead}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Carousel for mobile */}
      <div className="carousel-container">
        <div className="carousel-inner">
          <button className="carousel-btn prev" onClick={prevSlide} aria-label="Previous slide">
            <ChevronLeft />
          </button>
          
          <div className="carousel-wrapper">
            <div 
              className="carousel-track" 
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                <div className="carousel-slide" key={slideIndex}>
                  <div className="carousel-slide-content">
                    {cards.slice(slideIndex * cardsPerSlide, (slideIndex + 1) * cardsPerSlide).map((card, cardIndex) => (
                      <div className="card" key={cardIndex}>
                        <div className="image">
                          <img src={card.img} alt="error" />
                        </div>
                        <div className="content">
                          <h3 style={{color:card.color}}>{card.head}</h3>
                          <span>{card.subhead}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button className="carousel-btn next" onClick={nextSlide} aria-label="Next slide">
            <ChevronRight />
          </button>
        </div>

        <div className="carousel-dots">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}